import React from 'react';

const SEVERITY_CONFIG = {
    critical: {
        border: '#ef4444',
        bg: 'rgba(239, 68, 68, 0.08)',
        badge: '#ef4444',
        icon: '🔴',
        label: 'Critical',
    },
    high: {
        border: '#f97316',
        bg: 'rgba(249, 115, 22, 0.08)',
        badge: '#f97316',
        icon: '🟠',
        label: 'High',
    },
    medium: {
        border: '#eab308',
        bg: 'rgba(234, 179, 8, 0.08)',
        badge: '#eab308',
        icon: '🟡',
        label: 'Medium',
    },
};

function GapCard({ gap }) {
    const cfg = SEVERITY_CONFIG[gap.severity] || SEVERITY_CONFIG.medium;

    return (
        <div
            style={{
                border: `1px solid ${cfg.border}`,
                background: cfg.bg,
                borderRadius: '12px',
                padding: '16px 20px',
                marginBottom: '12px',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
            }}
            onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = `0 4px 20px ${cfg.border}30`;
            }}
            onMouseLeave={e => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = 'none';
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                <span style={{ fontSize: '16px' }}>{cfg.icon}</span>
                <span style={{
                    fontWeight: '700',
                    fontSize: '14px',
                    color: '#f1f5f9',
                    flex: 1,
                }}>
                    {gap.title}
                </span>
                <span style={{
                    background: cfg.badge,
                    color: '#fff',
                    fontSize: '10px',
                    fontWeight: '700',
                    padding: '2px 8px',
                    borderRadius: '100px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                }}>
                    {cfg.label}
                </span>
                <span style={{
                    background: 'rgba(255,255,255,0.08)',
                    color: '#94a3b8',
                    fontSize: '10px',
                    padding: '2px 8px',
                    borderRadius: '100px',
                }}>
                    {gap.category}
                </span>
            </div>

            <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#cbd5e1', lineHeight: '1.5' }}>
                {gap.description}
            </p>

            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                fontSize: '12px',
            }}>
                <span style={{ color: '#22d3ee', fontWeight: '600', whiteSpace: 'nowrap' }}>→ Fix:</span>
                <span style={{ color: '#94a3b8' }}>{gap.suggestion}</span>
            </div>

            {gap.stat && (
                <div style={{
                    marginTop: '10px',
                    padding: '8px 12px',
                    background: 'rgba(255,255,255,0.04)',
                    borderRadius: '8px',
                    fontSize: '12px',
                    color: '#22d3ee',
                    fontStyle: 'italic',
                }}>
                    📊 {gap.stat}
                </div>
            )}
        </div>
    );
}

export default function GapAlertsPanel({ gaps = [], techDebtFlags = [] }) {
    if (!gaps.length && !techDebtFlags.length) return null;

    const criticalCount = gaps.filter(g => g.severity === 'critical').length;
    const highCount = gaps.filter(g => g.severity === 'high').length;

    return (
        <div style={{
            background: 'rgba(15, 20, 40, 0.6)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '16px',
            padding: '24px',
            marginBottom: '24px',
        }}>
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
                <div style={{
                    width: '40px', height: '40px', borderRadius: '10px',
                    background: 'rgba(239, 68, 68, 0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '20px',
                }}>
                    🔍
                </div>
                <div>
                    <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: '#f1f5f9' }}>
                        Automation Gap Analysis
                    </h3>
                    <p style={{ margin: 0, fontSize: '12px', color: '#94a3b8' }}>
                        {gaps.length} gap{gaps.length !== 1 ? 's' : ''} detected
                        {criticalCount > 0 && ` — ${criticalCount} critical`}
                        {highCount > 0 && `, ${highCount} high priority`}
                    </p>
                </div>
            </div>

            {/* Gap cards */}
            <div>
                {gaps.map((gap, idx) => (
                    <GapCard key={idx} gap={gap} />
                ))}
            </div>

            {/* Tech debt flags */}
            {techDebtFlags.length > 0 && (
                <div style={{ marginTop: '16px' }}>
                    <div style={{
                        fontSize: '12px', fontWeight: '600', color: '#94a3b8',
                        marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px',
                    }}>
                        ⚠️ Tech Debt Detected
                    </div>
                    {techDebtFlags.map((flag, idx) => (
                        <div key={idx} style={{
                            padding: '8px 12px',
                            background: 'rgba(234, 179, 8, 0.06)',
                            border: '1px solid rgba(234, 179, 8, 0.2)',
                            borderRadius: '8px',
                            fontSize: '12px',
                            color: '#fbbf24',
                            marginBottom: '6px',
                        }}>
                            {flag}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
